export default __webpack_public_path__ + "static/b_helles_04-984c841445282899ff8069b4548d7c99.png";